import { useState } from "react";
function useIsHovering() {
  const [isHovering, setIsHovering] = useState(false);
  return {
    isHovering,
    startHover,
    endHover
  };
  function startHover() {
    setIsHovering(true);
  }
  function endHover() {
    setIsHovering(false);
  }
}
export {
  useIsHovering as default
};
//# sourceMappingURL=use-is-hovering.es.js.map
